// @flow
import { createAction } from 'redux-actions';

export const login = createAction(
  'LOGIN_REQUEST',
  (payload: LoginRequestBody) => payload
);

export const logout = createAction('LOGOUT');

export const receiveAuth = createAction(
  'LOGIN_RESPONSE',
  (payload: LoginResponseBody) => payload
);

export const regenerateToken = createAction(
  'REGENERATE',
  (clientId: ?number) => clientId
);



// WEBPACK FOOTER //
// ./src/ducks/authActions.js